import { render, staticRenderFns } from "./ParallaxObject.vue?vue&type=template&id=0c60c004&"
import script from "./ParallaxObject.vue?vue&type=script&lang=js&"
export * from "./ParallaxObject.vue?vue&type=script&lang=js&"
import style0 from "./ParallaxObject.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports